import React from 'react'
import Navbar from '../inc/Navbar'
import carrierac from "../images/carrier ac.jpg"
import { Link } from 'react-router-dom'
import ToshibaStablePowerInverter4HP from "../images/RAV-SE561UP_RAV-TE561AP.png";
import DuctedInverter from "../images/Inverter_Duckted.jpg";
import Ducted from "../images/carrier Inverter_Ducted_-_Indoor.jpg";

import carrier_CassetteR32 from "../images/careir r32_product.jpg";



function Carrier() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <div className='ackrishnagar'>
        <div className="album py-1">
          <div className="container mt-2">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Carrier</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <img src={carrierac} className="d-block w-100" alt="carrierac_krishnagar" />

      <br />
      <div className="album py-1 ">

        <div className="container mt-2">
          <center>
            <h3 className='mb-3' style={{ color: "grey" }}><b>Air Conditioning Systems</b></h3>
            <h5>SMART COOLING. SMARTER COMFORT.
At Saha Refrigeration, we deliver reliable, energy-efficient and low-noise air conditioning solutions powered by Carrier technology.</h5>
          </center>
          <br />
        </div>
      </div>

      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={carrier_CassetteR32} className="card-img-top" alt="carrier_CassetteR32" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">CassetteR32</h5>
                  <p className="card-text describe mb-2"><small>Capacity Range (kW): 5.3-13.48</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>
            
              <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={Ducted} className="card-img-top" alt="carrier Ducted"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">Ducted</h5>
                  <p className="card-text mb-2"><small>Capacity Range (kW): 10.6~59.8</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={DuctedInverter} className="card-img-top" alt="DuctedInverter" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Ducted Inverter</h5>
                  <p className="card-text mb-2"><small>
                    3 HP 5 STAR</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>








          </div>
        </div>
      </div>
      <br />

    </div>
  )
}

export default Carrier